import React from "react";
import PropTypes from "prop-types";
import { Grid, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import LanguageSelector from "components/menu/LanguageSelector";

const useStyles = makeStyles(publicMainStyle);

const FooterMain = (props) => {
  const { openStatement, onOpenStatement, userPrivacyAgreementNeeded = false, isPublic = false } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container alignItems="center" justifyContent="space-between" className={classes.gridFooter}>
      <Grid item className={classes.gridFooterItem}>
        <LanguageSelector miniActive={false} />
      </Grid>
      {!userPrivacyAgreementNeeded && !openStatement && (
        <Grid item className={classes.gridFooterItem}>
          <Button onClick={onOpenStatement} className={classes.buttonFooter}>
            {isPublic && openStatement ? t("PublicInfo.BackToDocumentUpload") : t("General.PrivacyStatement")}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

FooterMain.propTypes = {
  openStatement: PropTypes.bool.isRequired,
  onOpenStatement: PropTypes.func.isRequired,
  userPrivacyAgreementNeeded: PropTypes.bool,
  isPublic: PropTypes.bool,
};

export default FooterMain;
